import React, {Component} from "react";
import { connect } from "react-redux";

class StatusBar extends Component {
  render() {
    let statusname = this.props.status;
    // if (statusname === "Default SIF/PIF")
    //   statusname = "Paid Off";
    if (statusname === "Originated")
      statusname = "Active";
    else if (statusname === "Closed")
      statusname = "Inactive";
    else if (statusname === "Withdrawn")
      statusname = "Expired";
    else if (statusname === "Pending")
      statusname = "Pending Verification";
    else if (statusname === "Pending")
      statusname = "Pending Verification";
    else if (statusname === "Pending Paid Off")
      statusname = "Final Payment Pending";

    if (statusname === "Active" || statusname === "Expired" || statusname === "Withdrawn" || statusname === "Default SIF/PIF" || statusname === "Default" || statusname === "Delinquent" || statusname === "Paid Off Pending"){
      return "";
    } else {
      return (
        <div className="statusbox text-center">
          <h5>Status: <span>{statusname}</span></h5>
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => ({
    status: state.FormReducer.status
});

export default connect(mapStateToProps)(StatusBar);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/partials/StatusBar.js